// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4a5f8817","889":"93654ab4","977":"8cf7b3a2"}[chunkId] + ".chunk.js";
};